import { IJointAnglesUR } from '../types/simconf/joint-angles-ur';

export const defaultRobotPose: IJointAnglesUR = {
  shoulder_pan_joint: 90,
  shoulder_lift_joint: -115,
  elbow_joint: 115,
  wrist_1_joint: -90,
  wrist_2_joint: -90,
};
